import React, { memo, useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { Button, message, Spin, Input, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { inject, observer } from 'mobx-react'
import DashboardLayout from '../../layouts/DashboardLayout'
import PageTitle from '../../components/PageTitle'
import MyFirstGrid from './MyFirstGrid'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ACL_ACTION_TYPE } from '../../constants'
import AccessControlAction from '../../components/AccessControlAction'

const TinTucPage = props => {
  const ref = useRef(null)
  let [width, setWidth] = useState(0)

  const { loadingAnimationStore, tintucStore, history } = props
  const { newsList, tinTucTotalCount } = tintucStore

  const [isLoadingTinTuc, setIsLoadingTinTuc] = useState(false)
  const [isSearching, setIsSearching] = useState(false)
  const [searchText, setSearchText] = useState('')
  const searchTimeoutRef = useRef(null)

  const loadTinTuc = async () => {
    try {
      setIsLoadingTinTuc(true)
      tintucStore.setTintucQueryParams({
        page: 0,
        size: 10,
        keyword: '',
      })
      await tintucStore.getAllNews()
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsLoadingTinTuc(false)
    }
  }

  const performSearch = async value => {
    try {
      console.log('🔎 performSearch called with keyword:', value)
      setIsSearching(true)
      setHasMore(true)
      tintucStore.clear()
      tintucStore.setTintucQueryParams({
        page: 0,
        size: 10,
        keyword: value,
      })
      console.log(
        '✅ queryParams after setTintucQueryParams:',
        tintucStore.tintucQueryParams
      )
      await tintucStore.getAllNews()
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsSearching(false)
    }
  }

  const handleSearch = value => {
    setSearchText(value)
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current)
    }

    searchTimeoutRef.current = setTimeout(() => {
      performSearch(value)
    }, 600)
  }

  useEffect(() => {
    setWidth(ref.current ? ref.current.offsetWidth : 0)
  }, [ref.current])

  useEffect(() => {
    ;(async () => {
      await loadTinTuc()
    })()
    return () => {
      tintucStore.clear()
    }
  }, [])

  const onItemClick = tinTuc => {
    history.push(`/utility/general-notifications/view/${tinTuc.id}`)
  }

  const onClickEdit = id => {
    history.push(`/utility/general-notifications/update/${id}`)
  }

  const onClickView = id => {
    history.push(`/utility/general-notifications/view/${id}`)
  }

  const onClickDelete = async id => {
    try {
      await tintucStore.delete(id)
      tintucStore.clear()
      await loadTinTuc()
    } catch (err) {
      console.log(err)
      message.success(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const [hasMore, setHasMore] = useState(true)
  const fetchMoreData = async () => {
    const scrollBox = document.getElementById('infinityScrollableDiv')
    if (newsList.length >= tinTucTotalCount) {
      setHasMore(false)
      scrollBox.scrollTo(
        0,
        scrollBox.offsetHeight * tintucStore.tintucQueryParams.page
      )
      return
    }
    tintucStore.setTintucQueryParams({
      ...tintucStore.tintucQueryParams,
      page: tintucStore.tintucQueryParams.page + 1,
    })
    try {
      await tintucStore.getAllNews()
      scrollBox.scrollTo(
        0,
        scrollBox.offsetHeight * tintucStore.tintucQueryParams.page
      )
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    }
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>Thông báo chung</title>
      </Helmet>
      <PageTitle location={props.location} title="Thông báo chung">
        <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Input
            placeholder="Tìm kiếm tiêu đề hoặc nội dung..."
            prefix={isSearching ? <Spin size="small" /> : <SearchOutlined />}
            value={searchText}
            onChange={e => handleSearch(e.target.value)}
            style={{
              width: 300,
              borderRadius: 6,
              fontSize: 13,
              opacity: isSearching ? 0.7 : 1,
            }}
            disabled={isSearching}
            allowClear
          />
          <AccessControlAction aclActionType={ACL_ACTION_TYPE.create__NEWS}>
            <Button
              onClick={() => {
                history.push('/utility/general-notifications/create')
              }}
              type={'primary'}
              style={{ borderRadius: 6 }}>
              ➕ Đăng thông báo
            </Button>
          </AccessControlAction>
        </Space>
      </PageTitle>
      <InfiniteScroll
        dataLength={newsList.length}
        next={fetchMoreData}
        hasMore={hasMore}
        style={{
          scrollSnapStop: 'always',
        }}
        scrollableTarget="infinityScrollableDiv"
        loader={
          <div
            style={{
              padding: '32px 0',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            {newsList.length > 10 && <Spin tip="Đang tải thêm..." />}
          </div>
        }>
        <div ref={ref}>
          {width > 0 && (
            <MyFirstGrid
              parentWidth={width}
              onItemClick={onItemClick}
              onClickView={onClickView}
              onClickEdit={onClickEdit}
              onClickDelete={onClickDelete}
              isLoading={isLoadingTinTuc || isSearching}
            />
          )}
        </div>
      </InfiniteScroll>
    </DashboardLayout>
  )
}

TinTucPage.propTypes = {}

export default memo(
  inject(
    'tintucStore',
    'loadingAnimationStore',
    'authenticationStore',
    'commonStore',
    'history'
  )(observer(TinTucPage))
)
